import classNames from 'classnames'
import { ReactElement } from 'react'
import { Tooltip } from 'app/components/Tooltip'
import type { Ad } from 'app/types/entities'
import type { CampaignJson } from 'app/types/entities'

const ICON_PATHS = {
  google: `/public/google_ads.png`,
  facebook: `/public/meta_icon.png`,
  callrail: `/public/callrail.png`,
  trackable: `/public/trackable.png`,
}

export function CampaignComboOption({
  campaign,
  workspaceId,
  selected,
  type,
  showCheckbox = true,
}: {
  campaign: CampaignJson
  workspaceId?: string
  selected: boolean
  type: Ad[`type`]
  showCheckbox?: boolean
}): ReactElement {
  return (
    <div
      className={classNames(
        `grid grow cursor-pointer items-center gap-2 py-1`,
        showCheckbox ? `grid-cols-[auto_1fr_auto]` : `grid-cols-[auto_1fr]`,
      )}
    >
      <img
        alt="platform icon"
        className="inline aspect-square h-auto w-5 shrink-0"
        src={ICON_PATHS[type as keyof typeof ICON_PATHS] ?? ICON_PATHS.trackable}
      />
      <Tooltip className="max-w-52 truncate" message={campaign.name}>
        <span className="text-body-xs text-default">{campaign.name}</span>
      </Tooltip>
      {showCheckbox && (
        <input
          name="option-checkbox"
          className="aspect-square h-4 shrink-0 rounded border-(--control-border) bg-surface-muted text-default outline-none focus:outline-none focus:ring-0 focus:ring-offset-0"
          type="checkbox"
          checked={selected}
          readOnly
        />
      )}
    </div>
  )
}
